import React from "react"
import { connectStats } from "react-instantsearch-dom"
import { Link } from "gatsby"

export const CustomWizardStats = connectStats(({ nbHits, more_hits_link }) => (
  <Link
    to={more_hits_link}
    className="tag is-mitternachtsblau-30 px-4 mb-auto has-text-weight-bold"
    style={{ borderRadius: "12px" }}
  >
    + {(nbHits - 4).toLocaleString()} weitere Vergaben
  </Link>
))
